<div class="icon-container">
  <i nz-icon [nzType]="iconType" nzTheme="outline"></i>
</div>
<div class="align-self-center">
  <div *ngIf="headerTextKey" class="text-center pt-4">
    <h1 class="h3">{{ headerTextKey | cxTranslate }}</h1>
  </div>

  <div *ngIf="contentTextKey" class="text-center mt-4">
    <p>
      {{ contentTextKey | cxTranslate }}
    </p>
  </div>
</div>
